import api from '../../../api';
import * as sendMessage from '../../../modules/trader-chat/actions/send-message';
import * as sendTyping from '../../../modules/trader-chat/actions/send-typing';

export function request(dispatch, { chatId, content }) {
    api.post('/chats/' + chatId + '/messages', { content: content })
        .then(() => {
            dispatch(sendTyping.stop(chatId));
            dispatch(sendMessage.finish(chatId));
        },
        (data) => dispatch(sendMessage.error(chatId, data.errors))
    );
}
